module.exports = __webpack_public_path__ + "static/media/logo-white.b48a4924.png";